$("form").submit(function (event) {

  var formData = {
    email: $("#email").val(),
    policy: $("#policy").is(":checked") ? 1 : 0,
    mailing: $("#mailing").is(":checked") ? 1 : 0,
  };

if(formData.email == ''){
  $("#email").addClass('error')
}else{
  $("#email").removeClass('error')
}
if(formData.policy == 0){
  $("#policy + label").addClass('error')
}else{
  $("#policy + label").removeClass('error')
}
if(formData.mailing == 0){
  $("#mailing + label").addClass('error')
}else{
  $("#mailing + label").removeClass('error')
}
if(formData.email != '' && formData.policy == 1 && formData.mailing == 1){
  $.ajax({
    type: "POST",
    url: "form/",
    data: formData,
    dataType: "json",
    success: function(data) {
      if (data.create==true){
	      $('.modal__info').hide()
	      $('.modal__done').fadeIn(200)
      }      
    }
  });
}

  event.preventDefault();
});


